import styled from 'styled-components';
import { mediaQuery } from '../../../../common/styles/styleUtil';

export const LogoWrapper = styled.div`
  display: flex;
  order: -1;
  align-items: flex-end;
  padding: 0 24px;
  width: 100%;
  height: 46px;

  @media (${mediaQuery.tablet}) {
    display: flex;
    flex-grow: 1;
    order: 0;
    align-items: center;
    height: auto;
    width: auto;
    padding: 0;
  }
`;

export const LogoImageWrapper = styled.a`
  width: 186px;
  height: 33px;

  @media (${mediaQuery.tablet}) {
    display: block;
    margin: 0 auto;
  }
`;
